/**
 * @file コンポーネント：ノート スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledNote = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background-color: #ffffff;
`;

export const StyledNoteBody = styled.div`
    flex-grow: 1;
    overflow-y: auto;

    &[data-disabled="true"] {
        .ql-editor {
            pointer-events: none;
        }
    }

    .ql-container {
        border: none;
        color: #000000;
    }

    .ql-editor {
        a {
            cursor: pointer;
        }
    }

    .ql-tooltip {
        display: none !important;
    }

    ol li[data-list="bullet"] {
        list-style: disc;
        padding-left: 0;
        margin-left: 1.5em;

        &::before,
        .ql-ui::before {
            content: "";
        }
    }

    .quill {
        height: 100%;
    }
`;

export const StyledNoteButton = styled.button`
    display: inline-flex;
    align-items: center;
    padding: 6px 12px;
    border: none;
    border-radius: 4px;

    &[data-type="delete"] {
        color: #ffffff;
        background-color: #ff505f;
    }

    &[data-type="save"] {
        color: #e4eefa;
        background-color: #2c7cda;
    }

    &:disabled {
        color: #868686;
        background-color: #d7d7d7;
    }
`;

export const StyledNoteButtonIcon = styled.span`
    width: 20px;
    margin-right: 8px;
    font-size: 20px;
    line-height: 24px;
    text-align: center;

    ${mediaQuery.sp(`
        width: 14px;
        margin-right: 4px;
        font-size: 14px;
    `)};
`;

export const StyledNoteButtonText = styled.span`
    font-size: 15px;
    line-height: 24px;

    ${mediaQuery.sp(`
        font-size: 11px;
    `)};
`;

export const StyledNoteNavigation = styled.div`
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
    padding: 8px;
`;

export const StyledNoteNavigationButtonlist = styled.ul`
    display: inline-flex;
`;

export const StyledNoteNavigationButtonlistItem = styled.li`
    margin-right: 16px;

    &:last-of-type {
        margin-right: 0;
    }
`;

export const StyledNoteNavigationHistory = styled.p`
    display: inline-flex;
    align-items: center;
    margin-right: 14px;
`;

export const StyledNoteNavigationHistoryIcon = styled.span`
    width: 24px;
    margin-right: 8px;
    color: #000000;
    font-size: 24px;
    line-height: 24px;
    text-align: center;

    ${mediaQuery.sp(`
        width: 14px;
        margin-right: 4px;
        font-size: 14px;
        line-height: 14px;
    `)};
`;

export const StyledNoteNavigationHistoryTime = styled.span`
    color: #000000;
    font-size: 14px;
    line-height: 16px;

    ${mediaQuery.sp(`
        font-size: 10px;
    `)};
`;

export const StyledNoteNavigationText = styled.p`
    display: inline-flex;
    align-items: center;
    margin-right: 14px;
    color: #1f73c1;
    font-size: 14px;
    line-height: 16px;
`;

export const StyledNoteToolbar = styled.div`
    background-color: #eeeeee;

    .is-android &,
    .is-ipad &,
    .is-iphone & {
        overflow-x: auto;
        white-space: nowrap;
    }

    &.ql-toolbar {
        flex-shrink: 0;
        border: none;

        .is-android &.ql-snow .ql-picker.ql-expanded .ql-picker-options,
        .is-ipad &.ql-snow .ql-picker.ql-expanded .ql-picker-options,
        .is-iphone &.ql-snow .ql-picker.ql-expanded .ql-picker-options {
            position: fixed;
            top: unset;
            left: 8px;
            width: calc(100% - 16px);
            min-width: auto;
        }
    }

    &::-webkit-scrollbar {
        width: 0;
        height: 0;
    }

    &:hover::-webkit-scrollbar {
        width: 16px;
        height: 16px;
    }
`;

export const StyledNoteToolbarButton = styled.button`
    color: #444444;
`;

export const StyledNoteToolbarItem = styled.div`
    margin-right: 0 !important;
`;

export const StyledNoteToolbarSelect = styled.select``;

export const StyledNoteToolbarSelectOption = styled.option``;
